import {isDate} from './is-type'

function parseNum(s: string): number | null {
    const n = Number(s)
    return Number.isNaN(n) ? null : n
}


export function parseTime(value: string|nil): [hour: number | null, minute: number | null] {
    if(!value?.length) return [null, null]

    let m
    if((m = value.match(/^\s*(\d{2}|xx?)(\d{2}|xx?)\s*$/i))) {
        return [parseNum(m[1]), parseNum(m[2])]
    } else if((m = value.match(/^\s*(\d{1,2}|xx?):(\d{2}|xx?)\s*([apx]m?)\s*/i))) {
        let hr = parseNum(m[1])
        const min = parseNum(m[2])
        if(hr != null) {
            if(hr === 12) hr = 0
            if(m[3][0].toLowerCase() === 'p') {
                hr += 12
            }
        }
        return [hr, min]
    }

    return [null, null]
}

export function parseDate(value: string|nil): [year:number,month:number,day:number]|null {
    if(!value?.length) return null
    const m = value.match(/^\s*(\d+)-(\d{2})-(\d{2})\s*$/)
    if(!m) return null
    return [Number(m[1]), Number(m[2]), Number(m[3])]
}

export function createDate(year: number, month: number, day: number) {
    return new Date(year,month-1,day,0,0,0,0);
}

export function createTime(hour: number, minute: number) {
    const date = new Date()
    date.setHours(hour, minute, 0, 0)
    return date
}

export function combineDateAndTime(date: string|nil, time: string|nil): Date|null {
    const dateTuple = parseDate(date)
    if(!dateTuple || dateTuple.some(v => v == null)) return null
    const timeTuple = parseTime(time)
    if(!timeTuple || timeTuple.some(v => v == null)) return null
    return new Date(dateTuple[0],dateTuple[1]-1,dateTuple[2],timeTuple[0]!,timeTuple[1]!,0,0)
}

/**
 * Parse a ISO8601 UTC date string.
 */
function parseUtcDateTimeString(date: string): Date {
    const m = /^(\d+)-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:Z|\+00:00)?$/.exec(date)
    if(m) {
        let [year, month, day, hour, min, sec] = m.slice(1/*exclude full match*/).map(n => Number(n))
        --month  // month is 0-indexed
        const wholeSec = Math.floor(sec)
        const ms = (sec - wholeSec) * 1000
        return new Date(Date.UTC(year, month, day, hour, min, sec, ms))
    }
    throw new Error("Could not parse date string")
}

export function parseUtcDateTime(date: string | number | Date): Date {
    if(typeof date === 'string') {
        return parseUtcDateTimeString(date)
    }
    if(typeof date === 'number') {
        return new Date(date)
    }
    if(isDate(date)) {
        return date
    }
    throw new Error("Not a date")
}
